/* ============================================================
   AP変更箇所ここから
   ③ 入荷連絡ボタン → 商品詳細への着地スクロール ＋ バリ変更時のトップ飛び補正
   ※このファイル全体が今回の新規追加分です。

   [Part 1] カードの「入荷連絡を受け取る」からの着地（#product-form 付き遷移時）
     ・SP（max-width:749px）: 商品タイトルへスクロール。
     ・PC: アプリ注入の「再入荷時に連絡を希望する」ボタンへ着地。
           無ければ #product-form へフォールバック。

   [Part 2] バリエーション変更時のトップ飛び補正（全来訪者・ハッシュ非依存）
     ・売切バリ選択時、テーマ再描画＋再入荷アプリのウィジェット再注入に伴い
       スクロールがページ最上部へ飛ぶ事象を補正する。
     ・トップへの不正ジャンプを検知したら、再入荷ウィジェット（表示時）へ、
       無ければ変更直前の位置へ引き戻す。

   AP: RESTOCK_LABEL はアプリ設定 button_label（settings_data.json）と一致。
   AP: MOBILE_MQ はSP判定のブレークポイント（テーマ基準 750px）。
   ============================================================ */
(function () {
  var HASH = '#product-form';
  var RESTOCK_LABEL = '再入荷時に連絡を希望する'; /* AP: アプリの button_label と一致させる */
  var MOBILE_MQ = '(max-width: 749px)';           /* AP: SP判定（Dawn基準 750px 未満） */
  var HEADER_FALLBACK = 100; /* --header-height 未設定時の予備オフセット(px) */
  var WAIT_MS = 5000;        /* PC: アプリ注入を待つ最大時間 */
  var GAP = 12;              /* 着地位置の余白(px) */
  var TOP_THRESHOLD = 60;         /* この値未満へ飛んだら「トップ飛び」とみなす(px) */
  var GUARD_MS = 3500;            /* バリ操作後の監視ウィンドウ(ms)。SPは再描画(fetch)が遅いので長め */
  var GUARD_INTERVAL = 100;       /* 監視間隔(ms) */
  var GUARD_MAX_CORRECTIONS = 4;  /* 1回のバリ操作あたりの最大補正回数 */

  /* ---------------- 共通ヘルパ ---------------- */
  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE_MQ).matches;
  }

  function headerOffset() {
    var h = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var n = parseInt(h, 10);
    return isNaN(n) ? HEADER_FALLBACK : n;
  }

  function isVisible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function scrollToEl(el, behavior) {
    requestAnimationFrame(function () {
      var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset() - GAP;
      window.scrollTo({ top: y < 0 ? 0 : y, behavior: behavior || 'smooth' });
    });
  }

  function findRestockFast() {
    var nodes = document.querySelectorAll('button, a, [role="button"], input[type="submit"], input[type="button"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var text = el.textContent || el.value || '';
      if (text.indexOf(RESTOCK_LABEL) !== -1 && isVisible(el)) return el;
    }
    return null;
  }

  function findRestockBroad() {
    var nodes = document.querySelectorAll('body *');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if ((el.textContent || '').indexOf(RESTOCK_LABEL) === -1) continue;
      var childHas = false;
      for (var j = 0; j < el.children.length; j++) {
        if ((el.children[j].textContent || '').indexOf(RESTOCK_LABEL) !== -1) { childHas = true; break; }
      }
      if (childHas) continue;
      if (isVisible(el)) return el;
    }
    return null;
  }

  /* =====================================================
     Part 1: カードからの着地
     ===================================================== */
  var landed = false;

  function titleEl() {
    return document.getElementById('product__title-sticky')
        || document.querySelector('.product__title')
        || document.getElementById('product-form');
  }

  function runMobile() {
    var el = titleEl();
    if (!el) return;
    scrollToEl(el);
    window.addEventListener('load', function () { scrollToEl(el); });
    setTimeout(function () { scrollToEl(el); }, 500);
  }

  function fallbackToAnchor() {
    var a = document.getElementById('product-form');
    if (a) a.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function attemptDesktopLanding() {
    if (landed) return true;
    var el = findRestockFast();
    if (el) {
      landed = true;
      scrollToEl(el);
      return true;
    }
    return false;
  }

  function runDesktop() {
    if (attemptDesktopLanding()) return;
    var obs = new MutationObserver(function () {
      if (attemptDesktopLanding()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () {
      obs.disconnect();
      if (landed) return;
      var el = findRestockBroad();
      if (el) { landed = true; scrollToEl(el); }
      else { fallbackToAnchor(); }
    }, WAIT_MS);
  }

  function startLanding() {
    if (isMobile()) runMobile();
    else runDesktop();
  }

  /* =====================================================
     Part 2: バリ変更時のトップ飛び補正
     ===================================================== */
  // バリピッカー領域（native select / スウォッチ / ピル）内の操作か
  function isVariantArea(t) {
    return t && t.closest && t.closest('variant-selects, .product-form__input');
  }

  var guardDeadline = 0, guardPrevY = 0, guardCorrections = 0, guardIv = null;

  // バリ操作を検知したら一定時間トップ飛びを監視し、飛んだら元の位置へ引き戻す。
  // SPはモバイル回線で再描画(fetch)＋アプリ再注入が1秒以上遅れて起きるため、
  // 監視ウィンドウを長め＋複数回補正で取りこぼしを防ぐ。
  function armGuard() {
    var y = window.pageYOffset;
    if (y < TOP_THRESHOLD) return;          // 元々ほぼ最上部なら守るものがない
    guardPrevY = y;
    guardDeadline = Date.now() + GUARD_MS;  // 既に監視中なら期限を延長
    guardCorrections = 0;
    if (guardIv) return;
    guardIv = setInterval(function () {
      if (Date.now() >= guardDeadline) { clearInterval(guardIv); guardIv = null; return; }
      // 想定外のトップ飛びを検知したら元の位置へ引き戻す（複数回まで）
      if (window.pageYOffset < TOP_THRESHOLD && guardPrevY >= TOP_THRESHOLD && guardCorrections < GUARD_MAX_CORRECTIONS) {
        window.scrollTo({ top: guardPrevY });
        guardCorrections++;
      }
    }, GUARD_INTERVAL);
  }

  function attachVariantGuard() {
    // product-info の子要素は再描画で入れ替わるため document 上で捕捉。
    // change（select/ラジオ）＋ click（スウォッチ/ピル/アプリUI）両方をトリガに。
    document.addEventListener('change', function (e) {
      if (isVariantArea(e.target)) armGuard();
    }, true);
    document.addEventListener('click', function (e) {
      if (isVariantArea(e.target)) armGuard();
    }, true);
  }

  /* ---------------- 起動 ---------------- */
  function boot() {
    if (window.location.hash === HASH) startLanding();
    attachVariantGuard();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
/* AP変更箇所ここまで */
